let React                = require("react");

let AssetAction          = require("../../controls/buttons/AssetAction.jsx");
let AddPackageButton     = require("../../controls/buttons/AddPackageButton.jsx");
let DetailsPackageButton = require("../../controls/buttons/DetailsPackageButton.jsx");

let PackageCard          = require("./PackageCard.jsx");

let ApplicationContext   = require("../../config/ApplicationContext.js");

class QtsearchCard extends React.Component {

    render() {
        let wrapperAddPackageButton = props => <AddPackageButton {...props} action={this.props.action} />
        let wrapperDetailsPackageButton = props => <DetailsPackageButton {...props} link={`${ApplicationContext.getPackageEditor()}?assetid=${this.props.resource.id}`} />

        return <PackageCard
                    {...this.props}
                    loginRequired={true}
                    switchThumbnail={true}
                    Action = {props => <AssetAction {...props} onClick={this.props.action}/>}
                    Buttons={{ grid:[], 
                                list:[wrapperAddPackageButton, wrapperDetailsPackageButton]}}
        		/>;
    }
}

module.exports = QtsearchCard;